import { render, staticRenderFns } from "./ClusteringMenu.vue?vue&type=template&id=feaaadf8&scoped=true"
import script from "./ClusteringMenu.vue?vue&type=script&lang=ts"
export * from "./ClusteringMenu.vue?vue&type=script&lang=ts"
import style0 from "./ClusteringMenu.vue?vue&type=style&index=0&id=feaaadf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaaadf8",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/user-search-result.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FClusteringMenu.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports